export default function singlePostArticle() {
    return {
      tocItems: [],
      readTime: '',
  
      init() {
        this.$nextTick(() => {
          this.generateTableOfContents();
          this.generateReadTime();
        });
      },
  
      generateTableOfContents() {
        const content = this.$refs.content;
  
        if (!content) {
          return;
        }
  
        const headings = Array.from(content.querySelectorAll('h3'));
        const usedIds = new Set();
  
        this.tocItems = headings
          .map((heading) => {
            const label = heading.textContent.trim();
  
            if (!label) {
              return null;
            }
  
            let id = heading.getAttribute('id');
  
            if (!id) {
              id = this.slugify(label);
              heading.setAttribute('id', id);
            }
  
            let uniqueId = id;
            let counter = 2;
  
            while (usedIds.has(uniqueId)) {
              uniqueId = `${id}-${counter}`;
              counter += 1;
            }
  
            if (uniqueId !== id) {
              heading.setAttribute('id', uniqueId);
            }
  
            usedIds.add(uniqueId);
  
            return {
              id: uniqueId,
              label,
            };
          })
          .filter(Boolean);
      },
  
      generateReadTime() {
        const content = this.$refs.content;
  
        if (!content) {
          return;
        }
  
        const text = content.textContent || '';
        const words = text.trim().split(/\s+/).filter(Boolean);
  
        if (!words.length) {
          return;
        }
  
        const minutes = Math.max(1, Math.ceil(words.length / 200));
  
        this.readTime = `${minutes} min read`;
      },
  
      slugify(value) {
        return value
          .toString()
          .toLowerCase()
          .trim()
          .replace(/&/g, 'and')
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-+|-+$/g, '');
      },
    };
  }